import type { PromotionConfigProvider } from './interfaces/promotion-config.provider'
import PromotionUrlTextbox from '../components/promotions/promotion-url-textbox.component.vue'

export function getPlatformPromotionConfigProvider(): PromotionConfigProvider<
  typeof PromotionUrlTextbox
> {
  return {
    promotionSettingConfigComponent: PromotionUrlTextbox,
  }
}
